export enum AppCurrency {
    BGN = 'BGN',
    EUR = 'EUR',
}
